  <template>
    <div class="backlog-view">
      <b-card v-for="item in items" :key="item.taskId">
          <b-card-text>
            <h5 class="card-title">
              <span class="text-muted">#{{item.taskId}}</span>
              {{item.title}}
            </h5>
              <b>Approved:</b> {{item.reviewer}} on {{item.approved}}
              <blockquote>{{item.description}}</blockquote>
          </b-card-text>
      </b-card>
    </div>
  </template>

  <script>
  export default {
    name: 'Backlog',
    props: ['items'],
    data() {
      return {
      }
    }
  };
  </script>